import { createAction, createAsyncAction } from 'typesafe-actions';
import { Campground } from './types';

export const fetchCampgrounds = createAsyncAction(
  'campgrounds/FETCH_REQUEST',
  'campgrounds/FETCH_SUCCESS',
  'campgrounds/FETCH_FAILURE'
)<void, Campground[], Error>();

export const updateParkName = createAction('campgrounds/UPDATE_PARK_NAME', resolve =>
  (text: string) => resolve(text)
);

export const updateParkCode = createAction('campgrounds/UPDATE_PARK_CODE', resolve =>
  (text: string) => resolve(text)
);

export const updateParkLatLong = createAction('campgrounds/UPDATE_PARK_LAT_LONG', resolve =>
  (latLong: string) => resolve(latLong)
);

export const fetchSuccessEmpty = createAction('campgrounds/FETCH_SUCCESS_EMPTY', resolve =>
  (text: string) => resolve(text)
);

export const getCampgrounds = (parkCode: string) => {
  return (dispatch: any) => {
    return dispatch((dispatch: any) => {
      dispatch(fetchCampgrounds.request());
      // const NPS_URL = 'https://developer.nps.gov/api/v1';
      // const KEY = 'hd0FOAAs8bVbTmoq2rWGKLDCtyk3lGodivqRYy3w';
      // const start = (1 - 1) * 10 + 1;
      // const campString = `/campgrounds?start=${start}&parkCode=${parkCode}&api_key=${KEY}`;
      // const url = `${NPS_URL}/${campString}`;
      const url = `/data/campgrounds/${parkCode}.json`;
      return fetch(url)
        .then(response => response.json())
        .then((json) => {
          if (json.data.length === 0) {
            dispatch(fetchSuccessEmpty(parkCode));
            // dispatch(fetchVisitorCenters.failure({
            //   parkCode,
            //   ...json.data,
            // }));
            return;
          }
          dispatch(fetchCampgrounds.success(json.data));
        });
    });
  }
}